import axios from 'axios/index'

import config from '../../config'
import action, { actionFailed } from '../../util/action'
import createAsyncConst from '../../util/createAsyncConst'

export const FETCH_STATUS = createAsyncConst('FETCH_STATUS')
export const CHANGE_VALUE = createAsyncConst('CHANGE_VALUE')
export const UPLOAD_DOC_MODEL = createAsyncConst('UPLOAD_DOC_MODEL')
export const DOWNLOAD_APK = createAsyncConst('DOWNLOAD_APK')
export const DOWNLOAD_FILE = createAsyncConst('DOWNLOAD_FILE')
export const DOWNLOAD_ORCAMENTO_MODEL_EXAMPLE = createAsyncConst(
  'DOWNLOAD_ORCAMENTO_MODEL_EXAMPLE'
)
export const FETCH_LAUNDRY_CONFIGS = createAsyncConst('FETCH_LAUNDRY_CONFIGS')
export const CHANGE_LAUNDRY_CONFIG = createAsyncConst('CHANGE_LAUNDRY_CONFIG')

export function fetchStatuses() {
  return dispatch => {
    dispatch(action(FETCH_STATUS.ACTION))
    return axios
      .get(`${config.API_URL}/change-status-settings`)
      .then(resp => {
        dispatch(action(FETCH_STATUS.SUCCESS, resp.data))
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_STATUS, e)))
  }
}

export function fetchLaundryConfigs(filters) {
  return dispatch => {
    dispatch(action(FETCH_LAUNDRY_CONFIGS.ACTION, {}, false, false))
    return axios
      .get(`${config.API_URL}/laundry-config`, {
        params: filters,
      })
      .then(resp => {
        dispatch(action(FETCH_LAUNDRY_CONFIGS.SUCCESS, resp.data, false, false))
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_LAUNDRY_CONFIGS, e)))
  }
}

export function changeConfigStatus(id, value) {
  return dispatch => {
    dispatch(action(CHANGE_LAUNDRY_CONFIG.ACTION, {}, false, false))
    return axios
      .put(`${config.API_URL}/laundry-config/${id}/status`, {
        is_active: value,
      })
      .then(resp => {
        dispatch(action(CHANGE_LAUNDRY_CONFIG.SUCCESS, resp.data, false, false))
        return resp
      })
      .catch(e => dispatch(actionFailed(CHANGE_LAUNDRY_CONFIG, e)))
  }
}

export function changeValueStatus(slug, value) {
  return dispatch => {
    dispatch(action(CHANGE_VALUE.ACTION))
    return axios
      .put(`${config.API_URL}/change-status-settings/${slug}`, { value })
      .then(resp => {
        dispatch(action(CHANGE_VALUE.SUCCESS, resp.data))
        return resp
      })
      .catch(e => dispatch(actionFailed(CHANGE_VALUE, e)))
  }
}

export function uploadDocModel(file) {
  return dispatch => {
    dispatch(action(UPLOAD_DOC_MODEL.ACTION))
    return axios
      .post(`${config.API_URL}/upload-doc-model`, file)
      .then(resp => {
        dispatch(action(UPLOAD_DOC_MODEL.SUCCESS, resp.data))
        return resp
      })
      .catch(e => dispatch(actionFailed(UPLOAD_DOC_MODEL, e)))
  }
}

export function getCurrentFileUrl() {
  return dispatch => {
    dispatch(action(DOWNLOAD_FILE.ACTION))
    return axios
      .get(`${config.API_URL}/get-current-file-url`)
      .then(async response => {
        dispatch(action(DOWNLOAD_FILE.SUCCESS, {}))
        return response
      })
      .catch(e => dispatch(actionFailed(DOWNLOAD_FILE, e)))
  }
}

export function downloadOrcamentoModelExample() {
  return dispatch => {
    dispatch(action(DOWNLOAD_ORCAMENTO_MODEL_EXAMPLE.ACTION))
    return axios
      .get(`${config.API_URL}/download-orcamento-model-example`, {
        responseType: 'blob',
        validateStatus: status => status <= 500,
      })
      .then(async response => {
        if (response.status !== 200) {
          const error = JSON.parse(await response.data.text())
          dispatch(
            actionFailed(DOWNLOAD_ORCAMENTO_MODEL_EXAMPLE, {
              response: {
                data: error,
              },
            })
          )
        } else {
          dispatch(action(DOWNLOAD_ORCAMENTO_MODEL_EXAMPLE.SUCCESS, {}))
          const blob = new Blob([response.data], { type: response.data.type })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          const contentDisposition = response.headers['content-disposition']
          let fileName = 'modelo-orcamento-exemplo.docx'
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename=(.+)/)
            if (fileNameMatch && fileNameMatch.length === 2) {
              fileName = fileNameMatch[1].replaceAll('"', '')
            }
          }
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        }
      })
  }
}

export function downloadAndroidApk() {
  return dispatch => {
    dispatch(action(DOWNLOAD_APK.ACTION))
    return axios
      .get(`${config.API_URL}/download-app/android`, {
        responseType: 'blob',
        validateStatus: status => status <= 500,
      })
      .then(async response => {
        if (response.status !== 200) {
          const error = JSON.parse(await response.data.text())
          dispatch(
            actionFailed(DOWNLOAD_APK, {
              response: {
                data: error,
              },
            })
          )
        } else {
          dispatch(action(DOWNLOAD_APK.SUCCESS, {}))
          const blob = new Blob([response.data], { type: response.data.type })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          const contentDisposition = response.headers['content-disposition']
          let fileName = `unknown.${response.data.type}`
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename=(.+)/)
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1].replaceAll('"', '')
            }
          }
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        }
      })
  }
}
